import React, { FC } from 'react';

import classes from './KTilePlaceholder.module.scss';
import { SelectPosActions } from '../ccson/TileMap';
import { getContainerStyle, getKTileStyle, getPivotStyle } from './KTileAsset';
import classNames from 'classnames';
import { KActionDTO, KPosition, Place } from '@envclient/envengine/src/envs/koenigsburg/KTile';

const KTilePlaceholder: FC<KTilePlaceholderProps> = (props) => {
  const { position, coord, actions, onClick } = props;
  const place: Place = {
    shape: 'triangle',
    positions: [position]
  };
  const { x, y } = position;

  const handleClick = () => {
    onClick({ selectedPos: { x, y }, posActions: actions });
  };

  // position top, left
  const tileStyle = getKTileStyle(place);
  const style = {
    left: tileStyle.left,
    top: tileStyle.top
  };

  // bg size, image and rotation
  const contStyle = getContainerStyle({ x, y }, 0, 'triangle');

  // pivot around central point
  const pivotStyle = getPivotStyle(place);

  const tileClasses = classNames(classes.tileItem, {
    [classes.hexa]: false,
    [classes.rhombus]: false,
    [classes.triangle]: true
  });

  const rotClasses = classNames(classes.rotCont, {
    [classes.hexa]: false,
    [classes.rhombus]: false,
    [classes.triangle]: true
  });

  return (
    <div className={tileClasses} style={style}>
      <div className={classes.pivotCont} style={pivotStyle}>
        <div className={rotClasses} style={contStyle} onClick={handleClick} data-ph-coord={coord}></div>
      </div>
    </div>
  );
};

interface KTilePlaceholderProps {
  position: KPosition;
  coord: string;
  actions: KActionDTO[];
  onClick: (payload: SelectPosActions<KActionDTO>) => void;
}

export default KTilePlaceholder;
